// src/components/CreateTeam.js
import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import {
  Container,
  TextField,
  Typography,
  Button,
  Paper
} from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { db } from "../../firebase-config";

const CreateTeam = () => {
  const { user } = useAuth();
  const [teamName, setTeamName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!teamName) {
      setError("Team name is required.");
      return;
    }

    try {
      setLoading(true);
      await addDoc(collection(db, "teams"), {
        teamName,
        description: description || "",
        createdBy: user.uid,
        members: [user.uid],    // The creator is automatically a member.
        admins: [user.uid],     // Optional: the creator becomes the admin.
        createdAt: serverTimestamp()
      });
      setSuccess("Team created successfully!");
      // Clear the form fields after successful creation.
      setTeamName("");
      setDescription("");
    } catch (err) {
      console.error("Error creating team:", err);
      setError("Failed to create team. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Create New Team
        </Typography>
        {error && (
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        )}
        {success && (
          <Typography variant="body1" color="success.main">
            {success}
          </Typography>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Team Name"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            rows={3}
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Team"}
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default CreateTeam;